// src/upload2R2.js
import * as AWS from "aws-sdk";

// Schlüssel im R2-Pfad sicher machen: nur erlaubte Zeichen durchlassen.
// Verhindert, dass z. B. ein versehentlich übergebener Dateiname (alte
// Aufrufe wie `uploadToR2(blob, "combined_xxx.png")`) den Pfad zerschießt.
function sanitizeUserScope(userId) {
    if (typeof userId !== "string") return "anon";
    const cleaned = userId.replace(/[^A-Za-z0-9_-]/g, "");
    return cleaned.length > 0 ? cleaned : "anon";
}

export async function uploadToR2(file, userId, _onProgress, folder = "uploads") {
    const s3 = new AWS.S3({
        region: "auto",
        signatureVersion: "v4",
        credentials: new AWS.Credentials("0ce0655eac9a3dcf0dc76383d585be93", "8abf46e48074bb150ca752c382aa8dfb30041491068097a939d0ae9c5641be63"),
        endpoint: "https://7ff81df9924eceed02f95392507dbe90.r2.cloudflarestorage.com",
    });

    // Generate a completely unique filename, ignoring the original file name
    const fileExtension = (file.name || "").split('.').pop() || "bin";
    const uniqueFileName = `${Date.now()}-${Math.random().toString(36).substring(2, 9)}.${fileExtension}`;
    const safeFolder = (folder || "uploads").replace(/^\/+|\/+$/g, "");
    const userScope = sanitizeUserScope(userId);

    // Pfad-Schema: <folder>/<userId>/<file>. Nicht-eingeloggte / Demo-
    // Uploads (kein userId) landen unter <folder>/anon/. Damit ist später
    // das gezielte Aufräumen pro User (DSGVO) ein einziges Prefix-Listing.
    const Key = `${safeFolder}/${userScope}/${uniqueFileName}`;

    const params = {
        Bucket: "pinkcatai",
        Key,
        Body: file,
        ContentType: file.type,
        ACL: "public-read",
    };
    await s3.upload(params).promise();
    return `https://r2.pinkcatai.com/${Key}`;
}

